import { value } from './brick-css.js';

export const brickMatrix = (
  config,
  canvasSize = { w: 0, h: 0 },
) => {
  const { w, h } = canvasSize;
  if (!w) console.error('wall height is invalid', { h });

  let totalWallHeight = 0;
  let currColWidth = 0;

  const matrix = [];
  for (let i = 0; i < 500; i++) {
    const row = [];
    currColWidth = 0;
    const stagger = value(config.stagger, i);

    for (let j = 0; j < 2000; j++) {
      const brick_w = +value(config.brick_w, [i, j], true);
      const brick_h = +value(config.brick_h, [i, j], true);
      const brick_gap = +value(config.brick_gap, [i, j], true);

      const bw = brick_w + brick_gap;
      const bh = brick_h + brick_gap;

      if (j === 0) {
        totalWallHeight += bh;
        currColWidth += brick_gap;
      }
      currColWidth += bw;

      if (totalWallHeight > h) {
        return matrix;
      }

      if (currColWidth > w) {
        break;
      } else {
        row.push(1);
      }
    }

    if (config._bpl) {
      // BPL uses CSS transform for stagger; ALL rows get same fill count so
      // justify-content:center produces the same base position for every row
      row.push(1); row.push(1); row.push(1);
    } else {
      // legacy: one extra fill brick to cover flex-center overhang
      row.push(1);
      // legacy stagger: extra brick shifts centering by half its width
      if (stagger === 'even' && i % 2 === 0) row.push(1);
      else if (stagger === 'odd' && i % 2 !== 0) row.push(1);
      else if (stagger) row.push(1);
    }

    matrix.push(row);
  }

  return matrix;
};
